module.exports = __webpack_public_path__ + "img/@team_img_05.96322975.jpg";